export const CommonMessages = {
    InternalServerError: {
        key: 'InternalServerError',
        message: 'Oops. Something went wrong. Internal server error.'
    },
    UnknownError: {
        key: 'UnknownError',
        message: 'Unknown error while communication with the server. Please try again later.'
    },
    UnauthorizedError: {
        key: 'UnauthorizedError',
        message: 'Unauthorized'
    },
    ForbiddenError: {
        key: 'ForbiddenError',
        message: 'Forbidden'
    },
    InvalidRoutePermission: {
        key: 'InvalidRoutePermission',
        message: 'Incorrect setup of route permission Check route data property.'
    }
};
